import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { numberFormat } from '../../../../../../../helpers/common/StringHelper';
import { propBool, propFunc, propShape, } from '../../../../../../../helpers/custom-prop-types';
import OfferInputColumn from './OfferInputColumn';
const OfferBottomRowPublic = (props) => {
    const { driverTargetRef, isActiveDriverTarget, onClickDriverTarget, rfp, viewRequest, } = props;
    const { id: rfpId } = rfp;
    const { id, offer: { additional_files: additionalFiles, is_view: isView, period, price, }, } = viewRequest;
    return (_jsxs("div", Object.assign({ className: 'bottom_row' }, { children: [_jsxs("div", Object.assign({ className: clsx('view_link_column', isActiveDriverTarget && 'is-driver-active'), onClick: onClickDriverTarget, ref: driverTargetRef, role: 'presentation' }, { children: [_jsx("span", Object.assign({ className: clsx('tag', isView ? 'tag_read' : 'tag_unread') }, { children: isView ? '既読' : '未読' })), _jsxs(Link, Object.assign({ className: 'view_link', to: `/project/client/${rfpId}/offer/${id}` }, { children: ["\u63D0\u6848\u5185\u5BB9\u3092\u898B\u308B", _jsx("i", { className: 'material-icons keyboard_arrow_right' })] }))] })), _jsx(OfferInputColumn, { hasAdditionalFiles: additionalFiles.length > 0, periodText: `約${period}週間`, priceText: `${numberFormat(price)}万円`, showAdditionalFiles: false })] })));
};
OfferBottomRowPublic.propTypes = {
    driverTargetRef: propShape(),
    isActiveDriverTarget: propBool(),
    onClickDriverTarget: propFunc(),
    rfp: propShape().isRequired,
    viewRequest: propShape().isRequired,
};
OfferBottomRowPublic.defaultProps = {
    driverTargetRef: null,
    isActiveDriverTarget: false,
    onClickDriverTarget: undefined,
};
export default OfferBottomRowPublic;
